import React, { useEffect, useCallback } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

export default function Lightbox({ images, currentIndex, onClose, onNavigate }) {
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowLeft') onNavigate((currentIndex - 1 + images.length) % images.length);
    if (e.key === 'ArrowRight') onNavigate((currentIndex + 1) % images.length);
  }, [currentIndex, images.length, onClose, onNavigate]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  if (currentIndex === null || !images || images.length === 0) return null;

  const currentImage = images[currentIndex];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-sm select-none animate-in fade-in duration-200">
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 p-3 rounded-full bg-slate-900/80 text-slate-400 hover:text-white hover:bg-slate-800 transition-all cursor-pointer"
        aria-label="Luk visning"
      >
        <X className="w-6 h-6" />
      </button>

      {/* Prev Button */}
      {images.length > 1 && (
        <button
          onClick={() => onNavigate((currentIndex - 1 + images.length) % images.length)}
          className="absolute left-4 z-50 p-3 rounded-full bg-slate-900/80 text-slate-400 hover:text-white hover:bg-slate-800 transition-all cursor-pointer"
          aria-label="Forrige billede"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
      )}

      {/* Next Button */}
      {images.length > 1 && (
        <button
          onClick={() => onNavigate((currentIndex + 1) % images.length)}
          className="absolute right-4 z-50 p-3 rounded-full bg-slate-900/80 text-slate-400 hover:text-white hover:bg-slate-800 transition-all cursor-pointer"
          aria-label="Næste billede"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      )}

      {/* Image Container */}
      <div className="relative max-w-[90vw] max-h-[85vh] flex flex-col items-center justify-center">
        <img
          src={currentImage}
          alt={`Galleri billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-sm shadow-2xl animate-in zoom-in-95 duration-200"
        />
        
        {/* Image Counter */}
        <div className="mt-4 text-xs text-slate-500 font-medium tracking-wider">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>
    </div>
  );
}
